var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.865 3C21.9884 6.86209 27.3702 8.87293 32.8701 8.6065C33.6708 11.4901 33.9158 14.5148 33.5905 17.5006C33.2652 20.4865 32.3763 23.3727 30.9766 25.9876C29.5769 28.6026 27.6949 30.8931 25.4425 32.7228C23.1901 34.5526 20.6132 35.8844 17.865 36.639C15.1168 35.8844 12.5399 34.5526 10.2875 32.7228C8.03512 30.8931 6.15313 28.6026 4.7534 25.9876C3.35367 23.3727 2.46476 20.4865 2.13948 17.5006C1.81421 14.5148 2.05922 11.4901 2.85995 8.6065C8.35979 8.87293 13.7416 6.86209 17.865 3",
    stroke: "#DADADA",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6356 20.9366C19.6578 20.9366 20.4865 20.0443 20.4865 18.9436C20.4865 17.843 19.6578 16.9507 18.6356 16.9507C17.6134 16.9507 16.7847 17.843 16.7847 18.9436C16.7847 20.0443 17.6134 20.9366 18.6356 20.9366Z",
    stroke: "#DADADA",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6338 20.9355V25.9179",
    stroke: "#DADADA",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.b955dd811417f77dc7f09ba948fb7012.svg";
export { ForwardRef as ReactComponent };